// extracted by mini-css-extract-plugin
export default {"tableHeaderColor":"#7fb5c8","textColor":"#4a4f55","anchorHoverColor":"#ff5d00","whiteColor":"#fff","blueDark":"#3f97b5"};